/**
 * Type definitions for Stock Class Feed Allocations
 *
 * - useStockClassQueries.ts for React Query hooks
 */

import { API } from "common/utils";
import { StockClass } from "model/animalGroupTypes";

export enum FEED_ALLOCATION_TYPE {
  STOCK_CLASS = "STOCK_CLASS",
  OFFSPRING = "OFFSPRING",
}

export interface StockClassFeedAllocation {
  guid: string;
  dateStart: string;
  allocatedBodyWeightFraction: number;
  allocationType: FEED_ALLOCATION_TYPE;
  stockClassGuid: string;
}

export const stockClassFeedAllocationApi = new API<StockClassFeedAllocation>(
  "stockClassFeedAllocations"
);

export type StockClassWiths = StockClass & {
  Values: Array<StockClassFeedAllocation>;
};
